/*
 * @Date: 2022-02-22 13:26:37
 * @Copyright: Frippler Copyright (c)
 * @LastEditors: Luis duchanglong@frippler.com
 * @LastEditTime: 2022-07-29 15:08:34
 * @FilePath: \mes-web\src\store\modules\commonStore.js
 * @Description: 通用配置数据管理
 */

import { messageStatApi } from "@/api/common/messageApi";
import { Loading } from "element-ui";
const commonStore = {
  state: {
    collapse: false,
    pindexChange: false,
    psize: Number(localStorage.getItem("__PSIZE__")) || 10,
    defaultAvatar: 'this.src="' + require("@/assets/default-avatar.png") + '"',
    noPic: 'this.src="' + require("@/assets/no-pic.png") + '"',
    fileUploadUrl: process.env.VUE_APP_API_HOST + "?c=utility&a=file&do=upload",
    defaultConsoleTitle: "MES 平台",
    messageNum: 0,
    startWorktime: 9,
    endWorktime: 18,
    restTime: [12, 13]
  },

  mutations: {
    SET_PSIZE: (state, val) => {
      localStorage.setItem("__PSIZE__", val || 10);
      state.psize = val || 10;
    },

    SET_COLLAPSE: (state, val) => {
      localStorage.setItem("__COLLAPSE__", val || false);
      state.collapse = val || false;
    },

    SET_PINDEX_CHANGE: (state, val) => {
      state.pindexChange = val;
    },
    SET_MESSAGE: (state, val) => {
      state.messageNum = val;
    }
  },

  actions: {
    getUnreadMessageNum ({ commit }) {
      return new Promise((resolve, reject) => {
        messageStatApi()
          .then(response => {
            if (!response.errno) {
              commit("SET_MESSAGE", response.data.cnt_unread);
            }
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};

export default commonStore;
